import i18n from './config'
import { apiRequest } from '../shared/api/base'

/**
 * Fetch the user's language preference from the server and sync i18n.
 * The DB is the source of truth; localStorage is just a pre-auth cache.
 */
export async function syncLanguageFromServer(): Promise<void> {
  try {
    const prefs = await apiRequest<{ language?: string }>('/settings/preferences')
    if (prefs.language && prefs.language !== i18n.language) {
      i18n.changeLanguage(prefs.language) // also updates localStorage via i18next cache
    }
  } catch {
    // Silently ignore — localStorage fallback is fine
  }
}
